import { render, staticRenderFns } from "./LoggedInLayout.vue?vue&type=template&id=5b726c61&scoped=true&"
import script from "./LoggedInLayout.vue?vue&type=script&lang=js&"
export * from "./LoggedInLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInLayout.vue?vue&type=style&index=0&id=5b726c61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b726c61",
  null
  
)

export default component.exports